import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import DashboardHeader from "../../components/Other/DashboardHeader";
import MomentumRead from "../../components/Edge/reads/momentum/MomentumRead";
import "../../components/Edge/core/edge.css";

// The Edge — Momentum, Phase 2 pilot. Reachable by URL only
// (/edge/momentum); no menu entry until the client approves the phase.
function MomentumPage() {
  const [sidebarToggle] = useOutletContext();

  // Focused lesson mode on a phone (client): the bottom nav is hidden for /edge/
  // routes (AuthLayout), and body.edge-read gives back the space the layout
  // reserves for it (edge.css). Removed on exit, so every other screen is as
  // before.
  useEffect(() => {
    document.body.classList.add("edge-read");
    return () => document.body.classList.remove("edge-read");
  }, []);

  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      {/* md:ml-60 clears the desktop sidebar. Top: pt-14 on mobile only clears
          the fixed header (the Contest wizard pages' mobile offset); desktop
          keeps pt-24. Bottom: no bottom nav inside a Read, so mobile keeps only
          a small gap above the device safe area. The mobile offsets here and
          the card's p-4 are what .edge-fit subtracts (edge.css). */}
      <div className="md:ml-60 bg-white pt-14 md:pt-24 pb-[calc(12px+env(safe-area-inset-bottom))] md:pb-16">
        {/* No card around the Read: on desktop the chart and the task panel
            sit side by side across the app's content width, and on a phone the
            chart runs edge to edge above the task panel (client layout
            references). The steps lay themselves out (SequenceStep). */}
        <div className="max-w-screen-xl mx-auto px-4 md:px-8 pt-3 md:pt-0">
          <MomentumRead />
        </div>
      </div>
    </>
  );
}

export default MomentumPage;
